









































import {Vue} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {getGooGleMapStyle, GoogleMapsMarker} from '@/utils/map';
import {MapOptions} from 'vue2-google-maps';
import {ClusterOptions} from 'vue2-google-maps/dist/components/cluster';
import {challengeCommunityModule} from '@/utils/store-acessor';
import {UserModel} from '@/models/user.model';

@Component({})
export default class ChallengerDetailCommunityMap extends Vue {
  @challengeCommunityModule.Getter('users') users!: UserModel[];
  @challengeCommunityModule.Getter('markers') markers!: GoogleMapsMarker[];
  markerSelected: number = 0;
  infoWindowShowing = false;
  center = {lat: 45.508, lng: -73.587};
  clusterOptions: ClusterOptions = {
    gridSize: 50,
    maxZoom: 15,
    styles: [
      {
        textColor: 'white',
        url: require('@/assets/icons/cluster.svg'),
        height: 30,
        width: 50,
      }
    ]
  };
  mapStyle: MapOptions = {
    styles: getGooGleMapStyle,
    mapTypeControl: false,
    clickableIcons: true,
    streetViewControl: false,
    zoomControl: true,
    zoom: 2,
    maxZoom: 15,
    fullscreenControl: true,
  };

  onMarkerClick(index: number) {
    this.markerSelected = index;
    this.infoWindowShowing = !this.infoWindowShowing
  }
}
